<div class="flex flex-auto flex-col p-6 md:p-8" style="height: 70%;">
  <!-- Close button -->
  <div class="flex items-center justify-end">
    <a mat-icon-button (click)="onCloseUpload()">
      <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
    </a>
  </div>
  <div
    class="border-2 border-dashed border-gray-400 rounded-lg p-6 py-16 text-center hover:bg-gray-100 min-h-48 flex flex-col items-center justify-center"
    style="height: 100%;" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
    [class.bg-gray-100]="isDragOver">
    <p class="text-lg font-medium">Drag & Drop your files here</p>
    <p class="text-sm text-gray-500 mt-2">or</p>
    <button mat-raised-button color="primary" (click)="fileInput.click()">Browse Files</button>
    <input type="file" #fileInput class="hidden" (change)="onFileSelected($event)" multiple />
  </div>

  @if(files.length > 0){
  <div class="mt-4">
    <h3 class="text-lg font-medium">Selected Files:</h3>

    @if (files.length > 1) {
    <div class="flex justify-end pb-4">
      <button mat-raised-button color="accent" aria-label="Upload all files" (click)="uploadAllFiles()">
        Upload All
      </button>
    </div>
    }
    <ul class="space-y-4">
      <li *ngFor="let file of files; let i = index"
        class="border-2 border-dotted rounded-lg p-4 flex flex-col justify-between">
        <!-- Filename Section -->
        <div class="flex items-center justify-between">
          <p class="font-medium">{{ file?.file?.name || 'No name available' }}</p>
          <div class="flex items-center space-x-4">
            <button mat-icon-button color="warn" (click)="removeFile(i)" *ngIf="!file.uploaded"
              aria-label="Remove file">
              <mat-icon>delete</mat-icon>
            </button>
            <button mat-raised-button color="primary" (click)="uploadFile(i)" [disabled]="file.uploaded"
              aria-label="Upload file">
              {{ file.uploaded ? 'Uploaded' : 'Upload' }}
            </button>
          </div>
        </div>
        <!-- Progress Bar Section -->
        <div class="relative mt-2 w-full">
          <mat-progress-bar mode="determinate" [value]="file.progress || 0" class="w-full"></mat-progress-bar>
          <div class="absolute inset-0 flex justify-center items-center">
            <p class="text-sm text-gray-700 font-medium  bg-white rounded-full px-2 py-1 border border-gray-300">{{
              file.progress || 0 }}%</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
  }
</div>